// extracted by mini-css-extract-plugin
export default {"grid_container":"style_grid_container__Hn6Yh","header":"style_header__ZQF4w","main":"style_main__v+ZpT","sidebar":"style_sidebar__Ge-WP"};